import { CommonRegistry } from '@common/components/components';

import { World } from '../World';

/**
 * Service that provides access to the World instance.
 * Used by systems to access world and component operations.
 *
 * Note: Stores World<CommonRegistry> but accepts any World that extends CommonRegistry.
 * The server/client base classes override getWorld() for properly typed access.
 */
export class WorldService {
  private world: World<CommonRegistry>;

  constructor(world: World<CommonRegistry>) {
    this.world = world;
  }

  /**
   * Get the world instance.
   * Server/client systems override getWorld() for proper typing.
   */
  getWorld(): World<CommonRegistry> {
    return this.world;
  }

  /**
   * Reset the service (for testing).
   */
  reset(world: World<CommonRegistry>): void {
    this.world = world;
  }
}
